(function(){
    'use strict'

    angular.module('app.archivoBNCR')
    .factory('ArchivoBNCRService', ArchivoBNCRService);

    ArchivoBNCRService.$inject = ['$http', '$q', 'apiSettings', 'UserInfoService'];

    function ArchivoBNCRService($http, $q, apiSettings, UserInfoService) {

        var api = {
            getArchivoBNCR: getArchivoBNCR
        };

        return api;

        function getArchivoBNCR(calendrizacionId){

            var url = apiSettings.apiBaseUrl + 'api/archivo-bncr/generar-archivo-env/' + UserInfoService.getCompaniaId() + '/' + calendrizacionId ;
            
            return $http.get(url, {
                responseType: 'arraybuffer'
            }).then(function (response) {
        
                var headers = response.headers();
                var fileName = headers['x-filename'];
                var contentType = headers['content-type'];

                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([response.data], { type: contentType });
                    var url = window.URL.createObjectURL(blob);
         
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", fileName);
         
                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                } catch (ex) {
                    console.log(ex);
                }
            }).catch(function (data) {
                console.log(data);
            });
        };

    };

})();